import React, { Component } from 'react'

import _ from 'lodash';
import moment from 'moment';

import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';


// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

import Button from 'components/CustomButtons/Button.jsx';

import ReactTable from "react-table"
import { reactTableDefaultProps } from 'helpers/reactTable';


// @material-ui/icons
import Dashboard from "@material-ui/icons/Dashboard";
import Schedule from "@material-ui/icons/Schedule";
import LooksOne from "@material-ui/icons/LooksOne";
import LooksTwo from "@material-ui/icons/LooksTwo";
import Looks3 from "@material-ui/icons/Looks3";
import Looks4 from "@material-ui/icons/Looks4";
import Looks5 from "@material-ui/icons/Looks5";
import Looks6 from "@material-ui/icons/Looks6";

import LocationOn from "@material-ui/icons/LocationOn";
import Gavel from "@material-ui/icons/Gavel";
import HelpOutline from "@material-ui/icons/HelpOutline";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import NavPills from "components/NavPills/NavPills.jsx";
import Accordion from "components/Accordion/Accordion.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";

import { cardTitle } from "assets/jss/material-dashboard-pro-react.jsx";

import OrgSelector from "views/Orgs/OrgSelector.jsx";
import * as DBHelper from "db";
import * as HTTPSHelper from "helpers/https";
import * as PhoneNumberHelper from "helpers/phoneNumber";
import { GAMETITLES } from "constants/enbrain_games";

const styles = {
  cardTitle,
  pageSubcategoriesTitle: {
    color: "#3C4858",
    textDecoration: "none",
    textAlign: "center"
  },
  cardCategory: {
    margin: "0",
    color: "#999999"
  }
};

class Migration extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loginInfo: [],
      enbrain: [],
      dementia: [],
      depress: [],
      stress: []
    }
  }
  handleFileChange = (e, mode) => {
    e.preventDefault();
    let reader = new FileReader();
    let file = e.target.files[0];
    reader.onloadend = () => {

      let result = JSON.parse(reader.result);

      switch (mode) {
        case 'dementia':
        case 'stress':
          result = _.groupBy(result, 'user_id');
          console.log('result = ', result);
          result = _.map(result, (value, key) => ({ user_id: key, data: _.groupBy(value, 'testDate') }));
          console.log('result = ', result);
          break;
        case 'depress': {
          const changeScore = (q_num, score) => {
            if ([1, 2, 5, 6, 13, 18, 19, 20, 22, 25, 26, 28, 29, 30].includes(q_num)) {
              return score === 1 ? 0 : 1;
            } else {
              return score;
            }
          };
          console.log('(*)result = ', result);
          result = result.map(item => ({ ...item, score: changeScore(item.q_Num, item.score) }));
          console.log('(**)result = ', result);
          result = _.groupBy(result, 'user_id');
          console.log('result = ', result);
          result = _.map(result, (value, key) => ({ user_id: key, data: _.groupBy(value, 'testDate') }));
          console.log('result = ', result);
          break;
        }
        case 'enbrain':
          result = _.groupBy(result, 'user_id');
          console.log('result = ', result);
          result = _.map(result, (value, key) => ({ user_id: key, data: value }));
          console.log('result = ', result);
          break;

        default:
        //do nothing
      }

      this.setState({
        [mode]: result
      });
    };
    reader.readAsText(file);
  };
  handleSubmit = e => {
    e.preventDefault();
    // this.state.file is the file/image uploaded
    // in this function you can save the image (this.state.file) on form submit
    // you have to call it yourself
  }


  renderUsers = () => {
    return (
      <ReactTable
        {...reactTableDefaultProps}
        data={this.state.loginInfo}
        columns={[
          {
            id: 'id',
            Header: "id",
            accessor: d => d.id
          },
          {
            id: '이름',
            Header: "이름",
            accessor: d => d.name
          },
          {
            id: '성별',
            Header: "성별",
            accessor: d => d.gender
          },
          {
            id: '나이',
            Header: "나이",
            accessor: d => d.age
          },
          {
            id: "phoneNum",
            Header: "전화번호",
            accessor: d => d.phoneNum
          },
          {
            id: "orgCd",
            Header: "기관코드",
            accessor: d => d.orgCd
          }
        ]}
      />
    )
  }


  renderEnbrainGames = () => {
    return (
      <ReactTable
        {...reactTableDefaultProps}
        data={this.state.enbrain}
        columns={[
          {
            id: 'id',
            Header: "id",
            accessor: d => d.id
          },
          {
            id: 'user_id',
            Header: "user_id",
            accessor: d => d.user_id
          },
          {
            id: 'gameNum',
            Header: "게임번호",
            accessor: d => d.gameNum
          },
          {
            id: 'q_Num',
            Header: "스테이지",
            accessor: d => d.q_Num
          },
          {
            id: "score",
            Header: "점수",
            accessor: d => d.score
          },
          {
            id: "playDate",
            Header: "게임실행일자",
            accessor: d => d.playDate
          }
        ]}
      />
    )
  }

  renderTest = (items) => {
    return (
      <ReactTable
        {...reactTableDefaultProps}
        data={items}
        columns={[
          {
            id: 'user_id',
            Header: "user_id",
            accessor: d => d.user_id
          },
          {
            id: '시험횟수',
            Header: "시험횟수",
            accessor: d => Object.keys(d.data).length
          },
          {
            id: '시험일자',
            Header: "시험일자",
            accessor: d => Object.keys(d.data).join(', ')
          },
          {
            id: "score",
            Header: "점수",
            accessor: d => {
              const scores = Object.values(d.data).map(items => {
                return _.sumBy(items, 'score')
              }).join(', ');
              return scores;
            }
          }
        ]}
      />
    )
  }


  doMigration = () => {
    console.log('do migration: ', this.props.currentOrg.id);
    const org_id = this.props.currentOrg.id;
    // 1. /users 에 생성하고
    const { loginInfo } = this.state;

    return loginInfo
      .map(async (item, index) => {
        const { id: old_id, name, phoneNum, age, gender, orgCd: org_cd } = item;
        const phone = PhoneNumberHelper.toE164(phoneNum);
        const birthday = `${2019 - age + 1}-01-01`;

        const d = {
          name,
          birthday,
          org_id,
          org_cd,
          old_id,
          gender: parseInt(gender)
        };
        if (phone.length < 10) {
          d['email'] = `${phoneNum}@pangyo.enbrain.com`;
          d['password'] = `111111`;
        } else {
          d['phone'] = phone;
          d['email'] = `${phoneNum}@pangyo.enbrain.com`;
          d['password'] = `111111`;
        }
        console.log(`data[${index}] = `, d);
        // return null;
        return await HTTPSHelper.setupMember(d);
      })
      .reduce((p, fn) => p.then(fn), Promise.resolve())
      .then(() => {
        const { enbrain } = this.state;
        return DBHelper.getUserIdsByOrgId(org_id)
          .then(user_map => {
            // console.log('user_map: ', user_map)
            return Promise.all(enbrain.map((item, index, arr) => {
              const { user_id: old_id, data = [] } = item;
              // console.log(`old_id: ${old_id} (${index + 1}/${arr.length})`);
              const found_user_map = _.find(user_map, { old_id: parseInt(old_id) });
              // console.log("found_user_map = ", found_user_map);
              if (!found_user_map) {
                return null;
              }

              const { user_id } = found_user_map;
              return Promise.all(data.map((game_result, i, arr) => {
                // console.log(`game result = ${i + 1}/${arr.length}`);
                // console.log("game_result: ", game_result)//, old_id: ${old_id}, game_result: ${game_result}`)
                const { gameNum: game_id, q_Num: now_stage, score, playDate } = game_result;
                const d = {
                  org_id,
                  created_at: moment(playDate).toDate(),
                  end_time: null,
                  game_id,
                  game_name: GAMETITLES[game_id - 1],
                  game_num: game_id,
                  now_stage: `${now_stage}`,
                  score,
                  start_time: null
                }
                // return null;//console.log(`user_id: ${user_id}, d = `, d);
                return DBHelper.saveGameResult(user_id, d);
              }))
            }))
          })
      })
      .then(() => {
        const { dementia } = this.state;
        return DBHelper.getUserIdsByOrgId(org_id)
          .then(user_map => {
            // console.log('user_map: ', user_map)
            return Promise.all(dementia.map((item, index, arr) => {
              const { user_id: old_id, data: obj } = item;
              const data = _.map(obj, (value, key) =>
                ({
                  org_id,
                  created_at: moment(key).toDate(),
                  end_time: null,
                  start_time: null,
                  game_name: "디멘시아",
                  ...value.reduce((p, cur) => ({ ...p, game_info: { ...p.game_info, [`question${cur.q_Num.toString().padStart(3, '0')}`]: { category: cur.category, score: cur.score, test_type: cur.testType } } }), {}),
                  total_score: _.sumBy(value, 'score'),
                }));
              // console.log(`old_id: ${old_id} (${index + 1}/${arr.length})`);
              const found_user_map = _.find(user_map, { old_id: parseInt(old_id) });
              // console.log("found_user_map = ", found_user_map);
              if (!found_user_map) {
                return null;
              }

              const { user_id } = found_user_map;

              return Promise.all(data.map((game_result, i, arr) => {
                console.log(`game result = ${i + 1}/${arr.length}`);
                // return null;
                // return console.log(`user_id: ${user_id}, d = `, game_result);
                return DBHelper.saveGameResult(user_id, game_result);
              }))
            }))
          })
      })
      .then(() => {
        const { depress } = this.state;
        return DBHelper.getUserIdsByOrgId(org_id)
          .then(user_map => {
            // console.log('user_map: ', user_map)
            return Promise.all(depress.map((item, index, arr) => {
              const { user_id: old_id, data: obj } = item;
              const data = _.map(obj, (value, key) =>
                ({
                  org_id,
                  created_at: moment(key).toDate(),
                  end_time: null,
                  start_time: null,
                  game_name: "우울증검사",
                  ...value.reduce((p, cur) => ({ ...p, game_info: { ...p.game_info, [`question${cur.q_Num.toString().padStart(3, '0')}`]: { score: cur.score } } }), {}),
                  total_score: _.sumBy(value, 'score'),
                }));
              console.log(`old_id: ${old_id} (${index + 1}/${arr.length})`);
              const found_user_map = _.find(user_map, { old_id: parseInt(old_id) });
              console.log("found_user_map = ", found_user_map);
              if (!found_user_map) {
                return null;
              }

              const { user_id } = found_user_map;

              return Promise.all(data.map((game_result, i, arr) => {
                console.log(`game result = ${i + 1}/${arr.length}`);
                // return null;
                // return console.log(`user_id: ${user_id}, d = `, game_result);
                return DBHelper.saveGameResult(user_id, game_result);
              }))
            }))
          })

      })
      .then(() => {
        const { stress } = this.state;
        return DBHelper.getUserIdsByOrgId(org_id)
          .then(user_map => {
            // console.log('user_map: ', user_map)
            return Promise.all(stress.map((item, index, arr) => {
              const { user_id: old_id, data: obj } = item;
              const data = _.map(obj, (value, key) =>
                ({
                  org_id,
                  created_at: moment(key).toDate(),
                  end_time: null,
                  start_time: null,
                  game_name: "스트레스검사",
                  ...value.reduce((p, cur) => ({ ...p, game_info: { ...p.game_info, [`question${cur.q_Num.toString().padStart(3, '0')}`]: { score: cur.score } } }), {}),
                  total_score: _.sumBy(value, 'score'),
                }));
              console.log(`old_id: ${old_id} (${index + 1}/${arr.length})`);
              const found_user_map = _.find(user_map, { old_id: parseInt(old_id) });
              console.log("found_user_map = ", found_user_map);
              if (!found_user_map) {
                return null;
              }

              const { user_id } = found_user_map;

              return Promise.all(data.map((game_result, i, arr) => {
                console.log(`game result = ${i + 1}/${arr.length}`);
                // return null;
                // return console.log(`user_id: ${user_id}, d = `, game_result);
                return DBHelper.saveGameResult(user_id, game_result);
              }))
            }))
          })

      })
      .catch(e => console.error("Migration failed: ", e))


    // 2. /groups/{group_id}/memebers 에 추가하고
    // 3. /users/{id}/game_results 에 enbrain_games, dementia, depress, stress 를 넣는다.
  }


  render() {
    const {
      loginInfo,
      enbrain,
      dementia,
      depress,
      stress
    } = this.state;
    const { classes } = this.props;

    return (
      <div>
        <h1>마이그레이션 페이지</h1>
        <OrgSelector />
        <div>
          loginInfo: <input type="file" onChange={e => this.handleFileChange(e, "loginInfo")} />
        </div>
        <div>
          enbrain games: <input type="file" onChange={e => this.handleFileChange(e, "enbrain")} />
        </div>
        <div>
          dementia: <input type="file" onChange={e => this.handleFileChange(e, "dementia")} />
        </div>
        <div>
          depress: <input type="file" onChange={e => this.handleFileChange(e, "depress")} />
        </div>
        <div>
          stress: <input type="file" onChange={e => this.handleFileChange(e, "stress")} />
        </div>
        <Button onClick={this.doMigration}>마이그레이션 시작</Button>

        <div>
          <GridContainer justify="center">
            <GridItem xs={12} sm={12} md={12}>
              <h3 className={classes.pageSubcategoriesTitle}>
                마이그레이션 상태
            </h3>
              <br />
              <NavPills
                color="warning"
                alignCenter
                tabs={[
                  {
                    tabButton: `유저(${loginInfo.length})`,
                    tabIcon: LooksOne,
                    tabContent: this.renderUsers()
                  },
                  {
                    tabButton: `엔브레인 게임(${enbrain.length})`,
                    tabIcon: LooksTwo,
                    tabContent: this.renderEnbrainGames()
                  },
                  {
                    tabButton: `치매검사(${dementia.length})`,
                    tabIcon: Looks3,
                    tabContent: this.renderTest(this.state.dementia)
                  },
                  {
                    tabButton: `우울증검사(${depress.length})`,
                    tabIcon: Looks4,
                    tabContent: this.renderTest(this.state.depress)
                  },
                  {
                    tabButton: `스트레스검사(${stress.length})`,
                    tabIcon: Looks5,
                    tabContent: this.renderTest(this.state.stress)
                  }
                ]}
              />
            </GridItem>
          </GridContainer>


        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    currentOrg: state.org.currentOrg,
  }
}

export default compose(
  withStyles(styles),
  connect(mapStateToProps)
)(Migration);

